<template>
  <v-container id="portfolio" fluid fill-height class="pa-0 ma-0 grey--text text--darken-3">
    <v-row justify="center" class="text-center my-10">
      <v-col cols="12">
        <span class="title font-weight-medium">Portfolio</span>
        <br /><span class="display-1 font-weight-bold">What I've been working on</span>
      </v-col>
      <v-col cols="12" class="ma-0 pb-10">
        <v-row justify="center">
          <v-col cols="2" class="ma-0 pa-0">
            <hr class="line-divider" />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="10">
        <PortfolioSelector />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PortfolioSelector from './components/PortfolioSelector'

export default {
  components: {
    PortfolioSelector
  }
};
</script>

<style scoped>
.line-divider {
  border-radius: 10px;
  background-image: linear-gradient(160deg,rgba(255,212,150) 0%, rgba(255,138,252) 88%);
  height: 5px;
  border: 0 none;
}

.hoverBtn {
  color: #BBB;
  transition: 0.5s;
  cursor: pointer;
}
.hoverBtn:hover {
  color: #777;
}
</style>
